import { render } from "./ResponsiveImageGallery.vue?vue&type=template&id=7655c8f9"
import script from "./ResponsiveImageGallery.vue?vue&type=script&lang=js"
export * from "./ResponsiveImageGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__